import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

async function fetchConfig() {
  const accessToken = window.localStorage.getItem('accessToken');
  const idUser = window.localStorage.getItem('idUser');

  if (!accessToken || !idUser) {
    throw new Error('Token ou idUser não encontrados no localStorage');
  }

  const options = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + accessToken,
    },
  };

  // 1) Terminal do usuário
  const terminalResp = await axios.get(
    `https://apihomologtechfood.techspdv.com.br/v1/terminal-comercial/usuario/${idUser}`,
    options
  );

  // parametros pode vir string JSON ou objeto; trata os dois casos
  let parametros: any = {};
  const rawParams = terminalResp.data?.parametros;
  if (rawParams != null) {
    if (typeof rawParams === 'string') {
      try {
        parametros = JSON.parse(rawParams || '{}');
      } catch {
        parametros = {}; // fallback seguro
      }
    } else if (typeof rawParams === 'object') {
      parametros = rawParams;
    }
  }

  const tpAmb = terminalResp.data?.tpAmb; // 1=produção, 2=homologação (em geral)
  let terminalObjeto: any = null;

  if (terminalResp.data?.idRefTerminalFiscal) {
    const terminalFiscalResp = await axios.get(
      `https://apihomologtechnfe.techspdv.com.br/v1/terminal/${terminalResp.data.idRefTerminalFiscal}`,
      options
    );
    terminalObjeto = terminalFiscalResp?.data ?? null;
  }

  // 2) Restaurante do usuário
  const restauranteResp = await axios.get(
    `https://apihomologtechfood.techspdv.com.br/v1/restaurantes/usuario/${idUser}`,
    options
  );
  const restaurante = restauranteResp?.data;

  // Normaliza CNPJ (só dígitos), caso venha formatado
  const cnpjEmissor = (restaurante?.cnpj || '').replace(/\D/g, '');
  let tokenInvoicy;
  try {
    // 3) Token Invoicy (via technfe-api)
    const tokenInvoicyResp = await axios.get(
      `https://apihomologtechnfe.techspdv.com.br/api/tokenInvoicy/getToken/${cnpjEmissor}`,
      options
    );
    tokenInvoicy = tokenInvoicyResp?.data;
  } catch (error) {

  }

  let certificadoResp;
  let mensagemCertificado;
  console.log(tokenInvoicy);
  if (tokenInvoicy) {
    // 4) Consulta de certificado na Invoicy
    // Usa tpAmb do terminal; se não houver, usa 2 (homologação) como fallback
    const tpAmbInvoicy = tpAmb ?? 2;
    console.log(`https://apibr.invoicy.com.br/senddocuments/nfe?type=Consulta&CnpjEmissor=${cnpjEmissor}&Versao=4.00&tpAmb=${tpAmbInvoicy}&dhUF=35`);
    console.log(tokenInvoicy.accessToken);

    try {
      console.log(`https://apihomologtechnfe.techspdv.com.br/api/tokenInvoicy/certificado/${cnpjEmissor}`);
      certificadoResp = await axios.get(
        `https://apihomologtechnfe.techspdv.com.br/api/tokenInvoicy/certificado/${cnpjEmissor}`,
        options
      );


      if (certificadoResp?.data?.Codigo == 100) {
        if (certificadoResp.data.Documentos[0].CertDiasValido > 0) {

          mensagemCertificado = `Seu Certificado Digital vence em ${certificadoResp.data.Documentos[0].CertDiasValido} dias!! Clique aqui para renovar.`;
        } else {
          mensagemCertificado = `Seu Certificado Digital esta vencido!! Clique aqui para renovar.`;
        }
      }
      else {
        certificadoResp = await axios.get(
          `https://technfce-api.herokuapp.com/api/tokenInvoicy/certificado/${cnpjEmissor}`,
          options
        );

        if (certificadoResp?.data?.Codigo == 100) {


          if (certificadoResp.data.Documentos[0].CertDiasValido > 0) {

            mensagemCertificado = `Seu Certificado Digital vence em ${certificadoResp.data.Documentos[0].CertDiasValido} dias!! Clique aqui para renovar.`;
          } else {

            mensagemCertificado = `Seu Certificado Digital esta vencido!! Clique aqui para renovar.`;
          }
        } else {
          mensagemCertificado = `Seu Certificado Digital esta vencido!! Clique aqui para renovar.`;
        }

      }
    } catch (err: any) {
      console.error('status', err?.response?.status);
      console.error('data', err?.response?.data);
      console.error('headers', err?.response?.headers);
      console.error('request-headers', err?.config?.headers);
      mensagemCertificado = 'Certificado Digital Não Encontrado! Clique aqui para Suporte!';
    }
  }




  const buscarBloqueios = async () => {
    try {
      const { data } = await axios.get(`https://apihomologtechspdv.techspdv.com.br/v1/usuarios/bloqueiosDoUsuario/${idUser}`, options);
      return data.bloqueiosDoUsuario;
    } catch (err: any) {
      console.error("Erro:", err?.response?.status, err?.response?.data || err?.message);
      return '';
    }
  };

  const bloqueiosDoUsuario = await buscarBloqueios();



  return {
    terminalComercial: parametros,
    tpAmb,
    idLoja: terminalResp.data?.idLoja,
    idRefTerminalFiscal: terminalResp.data?.idRefTerminalFiscal,
    idTerminalComercial: terminalResp.data?.id,
    nomeTerminalComercial: terminalResp.data?.nome || '',
    serie: terminalObjeto?.serie || '',
    certificado: certificadoResp?.data,
    restaurante,
    tokenInvoicyRest: tokenInvoicy,
    mensagemCertificado: mensagemCertificado,
    tokenMarketplace: restaurante.tokenMarketplace || '',
    bloqueiosDoUsuario: bloqueiosDoUsuario || ''
  };
}

export function useConfigQuery() {
  return useQuery({
    queryKey: ['config'],
    queryFn: fetchConfig,
    staleTime: 1000 * 60 * 30, // 30 minutos
    // opcional: evita GC por 1h
    // gcTime: 1000 * 60 * 60,
  });
}
